export const TTD = 'ttd';
export const DOOH = 'dooh';
export const OOH = 'ooh';
export const PDOH = 'PDOH';
export const DIGITAL = 'DIGITAL';
export const FOOTFALL = 'FOOTFALL';
export const NO_FOOTFALL = 'NO_FOOTFALL';
export const HIVESTACK = 'hivestack';
export const FACEBOOK = 'facebook';
export const AMOBEE = 'amobee';
export const TWITTER = 'twitter';
export const GOOGLEMP = 'gmp';
export const PlanDeleteMessage = 'Plan deleted successfully.';
export const SCREEN_FORMAT = 'screenFormat';
export const PACKAGE = 'PACKAGE';
export const isTTD = 'isTTD';
export const isHiveStack = 'isHiveStack';
export const OBJECT = 'object';
export const POSTCODE = 'PostCode';
export const PACKAGES = 'packages';
export const GCS = 'GCS';
export const GCS_CREDENTIAL = 'GCS Credential';
export const DESTINATION = 'destination';
export const WEBSITE = 'Website';
export const ADVERTISING = 'Advertising';
export const INITIAL = 'INITIAL';
export const PROGRESS = 'PROGRESS';
export const FAILED = 'FAILED';
export const SUCCESS = 'SUCCESS';
export const CONTINUE = 'CONTINUE';
export const POI_PACKAGE = 'POI_PACKAGE';
export const POI = 'POI';

export const skeleton = {
  loader: {
    pending: false,
    fulfilled: false,
    rejected: false,
  },
  data: [],
  error: {},
};
export const pending = {
  pending: true,
  fulfilled: false,
  rejected: false,
};
export const fulfilled = {
  pending: false,
  fulfilled: true,
  rejected: false,
};
export const rejected = {
  pending: false,
  fulfilled: false,
  rejected: true,
};

export const HOME_POSTCODE = 'home_postcode';
export const WORK_POSTCODE = 'work_postcode';
export const HOME_POSTCODE_LABEL = 'Home Postcode';
export const WORK_POSTCODE_LABEL = 'Work Postcode';

export const POSTCODES = [
  {
    value: WORK_POSTCODE,
    label: 'Work PostCode',
    data: [],
    isPostCode: true,
  },
  {
    value: HOME_POSTCODE,
    label: 'Home PostCode',
    data: [],
    isPostCode: true,
  },
];

export const MAPPED = 'MAPPED';
export const UNMAPPED = 'UNMAPPED';
export const EMPTY_FILE = 'File is empty';
export const FILE_UPLOAD_SIZE_ERROR =
  'File size is more than 50MB, please upload smaller file';
export const ERROR = 'error';
export const EMPTY_STRING = '';

export const GALLERY_FILTER_SELECTION = {
  MEDIA_OWNER: 'mediaOwnerName',
  LEVEL_2: 'childCategoryName',
};

export const CLICK = 'Click';
export const CLICKS = 'Clicks';
export const VISIT_RATE = 'Visit Rate';
export const DEVICE_BASED_EXPOSURES = 'Device Based Exposures';
export const UNIQUE_REACH = 'Unique Reach';
export const IMPRESSSION = 'Impressions, Clicks';
export const IMPRESSSIONS = 'Imperssions';
export const REACH_DAY_AND_TIME = 'Reach Day & Time';
export const ENGAGEMENT_DAY_AND_TIME = 'Engagement Day & Time';
export const SPACE_DIGITAL = ' digital';
export const GROUPM_EMAIL_DOMAIN = 'groupm.com';
export const GROUPM_ERROR_MESSAGE =
  'Groupm users should login via OKTA. Please click Login with OKTA button';

export const emailRex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i;

export const show_ACCOUNT_LIST = [
  'vijay_sight@lifesight.io',
  'sharmishta@lifesight.io',
  'nikithasl@lifesight.io',
  'manjunath_sl@lifesight.io',
  'nikithasl_prod@lifesight.io',
];

export const ADMIN_USERS = [
  ...show_ACCOUNT_LIST,
  'samuel.villaroman@groupm.com',
  'dhruvil.bhatt@groupm.com',
];

export const POI_PACKAGE_NAME_REGEX = /[^a-zA-Z0-9\s_'-]/;

export const DISTANCE_ERROR_MESSAGE = 'Distance must be between 0.05 and 10 KM';
export const DISTANCE_MIN_VALUE = 50;
export const DISTANCE_MAX_VALUE = 10000;
export const DISTANCE_STEP = 50;
export const KM = 'KM';
export const DISTANCE = 'distance';

export const POI_PACKAGE_STATUS = {
  INITIAL: 'initial',
  ONGOING: 'ongoing',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const INTERESTS = 'interests';
export const BRAND = 'BRAND';
export const CATEGORY = 'CATEGORY';

export const SELECT_ALL_CLEAR = ['selectAll', 'clear'];
export const POST_CODE = 'postCode';
export const OUTDATED_PLAN_INFO =
  'Plan outdated - recent supply changes detected. Edit and save to update with current screens.';
export const MISSING_SCREENS_TOOLTIP =
  'Download the missing screens list, add the required details, and upload it under Edit Measurement Settings to remove this error';
export const SCREEN_STATUS = {
  MISSING_SCREENS: 'Pending User Action',
  UPLOADED: 'Updating Insights',
  PROCESSING: 'Updating Insights',
  COMPLETED: 'Completed',
};
export const SCREEN_STATUS_TOOLTIP = {
  MISSING_SCREENS: MISSING_SCREENS_TOOLTIP,
};

export const SCREEN_STATUS_COLOR = {
  MISSING_SCREENS: '#b0a9a9',
  UPLOADED: '#2a0c66',
  PROCESSING: '#2a0c66',
  COMPLETED: 'green',
};
export const MEASUREMENTS = {
  OOH: 'OOH',
  DIGITAL: 'DIGITAL',
  WEBSITE_LANDING: 'WEBSITE_LANDING',
};

export const USER_TYPE = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  MEMBER: 'MEMBER',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export const CREATE_USER_TYPE = [
  USER_TYPE.ADMINISTRATOR,
  USER_TYPE.SUPER_ADMIN,
];

export const TOAST_TYPE_BY_STATUS = {
  202: 'info',
  422: 'warning',
  500: 'error',
};

export const MAP_EVENTS = {
  zoom: 'zoom',
  dragend: 'dragend',
  click: 'click',
};
